var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "91 15.078 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 15.078c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5Zm-6 7.5c0-3.315 2.685-6 6-6 1.388 0 2.663.473 3.675 1.268l-8.407 8.407a5.927 5.927 0 0 1-1.268-3.675Zm6 6a5.927 5.927 0 0 1-3.675-1.267l8.408-8.408a5.927 5.927 0 0 1 1.267 3.675c0 3.315-2.685 6-6 6Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon material-block"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/BlockIcon.2f64e9a2eeb59342dd04f0942e1a463a.svg";
export { ForwardRef as ReactComponent };